<template>
<div>
    <div class='header-wrapper'>
        <!-- <LockItInHeader/> -->
    </div>

    <LockItInSummary :current_bottles='total_cart_quantity' :cart_totals='cart_totals' :lock_it_in_data='lock_it_in_data' :loading='loading' />

    <div class='product-container'>

        <div v-if='loading' class='loading-container'>
            <Loading/>
        </div>

        <div  v-if='!loading' class="product-breadcrumbs">
            <div><Breadcrumbs/></div>
            <!-- <div class="product-sku">SKU <span class="code">{{product.code}}</span></div> -->
        </div>
        <div v-show='!loading' class='top-container'>
            <div>
                <DynamicImageContainer v-if="product.images && product.images.length" class="product-image" :image="product.main_picture"/>
                <!-- <AddToWishList :product='product'/> -->
            </div>
            <div class="info-main-container">
                <ProductInfo :product='product' @updatedCartListener='updatedCartListener' @addToCartListener="addedToCart" @removedFromCartListener="removedFromCart"/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ProductImages from '@/ecom/components/products/single_product/images/ProductImages.vue';
import ProductInfo from '@/ecom/components/products/single_product/details/ProductInfo.vue';
import Breadcrumbs from '@/ecom/components/products/Breadcrumbs.vue';
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import AddToWishList from '@/ecom/components/products/single_product/details/AddToWishList.vue';
import Loading from '@/ecom/components/loading/Loading.vue';
// import LockItInHeader from '@/ecom/components/header/lock_it_in/LockItInHeader.vue';
import LockItInSummary from '@/ecom/components/header/lock_it_in/LockItInSummary.vue';
import {checkAuth, setMetaTags, triggerPrerenderEvent, checkOmetriaLoaded} from "@/global/modules/functions.js";

export default {
    components: {ProductImages, ProductInfo, Breadcrumbs, DynamicImageContainer, AddToWishList, Loading, LockItInSummary},
    emits: ['updatedCartListener','addToCartListener', 'removedFromCartListener'],
    props: ['user_info'],
    data(){
        return{
            product: {},
            stock: {},
            total_reviews: 0,
            average_rating: 0,
            loading: true,
            cart_totals: {
                total_quantity: 0,
                total_before_discounts: 0,
                dicsounts: 0,
                total_with_discounts: 0
            },
            lock_it_in_data: {
                quantity: 0
            },
            total_cart_quantity: 0
        }
    },
    methods:{
        async getProduct(){
            this.loading = true;
            const product_url = this.$route.path.split('/').filter(Boolean).pop();
            let response = await fetch(`/api/product?product_url=${product_url}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                setMetaTags(results.product.meta_title, results.product.meta_description, results.product.meta_keywords);
                this.product = results.product;
                this.loading = false;

                this.stock = results.stock;
                triggerPrerenderEvent();
                if(checkOmetriaLoaded()) {
                    ometria.init('product', {pid:this.product.code}, '501');
                    if(this.user_info.Email) ometria.identify(this.user_info.Email); 
                }
            }
        },
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        async getTotalCartItems(){
            let response = await fetch(`/api/lock-it-in/cart-totals`, {
                method: 'GET'
            });

            let results = await checkAuth(response);

            if (response.status === 200){
                this.total_cart_quantity = results;
                this.cart_totals = results;
            }
        },
        async getLockItInData(){
            let response = await fetch(`/api/lock-it-in/data`, {
                method: 'GET'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.lock_it_in_data = results;
            }
        },
        addedToCart(product, quantity){
            this.product.locked_in = true;
            this.getTotalCartItems();
        },
        removedFromCart(product, quantity){
            this.product.locked_in = false;
            this.getTotalCartItems();
        },
    },
    beforeMount(){
        this.getTotalCartItems();
        this.getLockItInData();
        this.getProduct();
    }
}
</script>

<style lang="scss" scoped>

.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
    margin-top: 50px;
}


.product-container{
    margin-bottom: 50px;
    padding-left: 150px;
    padding-right: 150px;

    @media(max-width:1432px) {
        padding-left: 100px;
        padding-right: 100px;
    }
    @media(max-width:1332px) {
        padding-left: 80px;
        padding-right: 80px;
    } 
    @media(max-width:1024px) {
        padding-left: 50px;
        padding-right: 50px;
    }  
    @media(max-width:768px) {
        padding-left: 20px;
        padding-right: 20px;
    }       
}
.top-container{
    display: flex;
    gap: 70px;
    margin-top: 30px;
    margin-bottom: 50px;
    padding-left: 50px;
    padding-right: 50px;

    @media(max-width:768px) {
        flex-wrap: wrap;
        gap:30px;
        justify-content: center;
        padding-left: 20px;
        padding-right: 20px;
    }
}
.product-image{
    width: 140px;
    object-fit: cover;
    text-align: left;
}
.info-main-container{
    width:100%;
}
.product-breadcrumbs{
    display:flex;
    justify-content: space-between;
    margin-top: 34px;
}
.product-sku{
    font-size: 1rem;
    font-weight: 400;
    line-height: 24px;
}
.code{
    font-weight: 600;
    padding-left: 4px;
    padding-right: 4px;
}

.header-wrapper{
    margin-bottom: 24px;
}
</style>